// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__22sOt","content":"RecentSearches_content__2uVGe"};